'use strict';

export default class ApiTokenService {
	static $inject = ['mx.SolutionBuilderAgent.Http', 'mx.SolutionBuilderAgent.DataService'];

	constructor(httpService, dataService) {
		this.httpService = httpService;
		this.dataService = dataService;
	}

	async generateAccessToken(apiTokenName = 'fe_token_service', httpHeaders = {}) {
		const apiToken = await this._generateApiToken(apiTokenName);
		const headers = Object.assign(
			{
				Authorization: 'Bearer ' + apiToken,
			},
			httpHeaders
		);
		const accessTokenRequest = await this.httpService.post(`api/sts/exchangeApiTokenToAccessToken`, {}, { headers });
		await this._deleteApiToken(apiTokenName);
		return accessTokenRequest.RawToken;
	}

	async _generateApiToken(apiTokenName) {
		const apiTokenResponse = await this.httpService.post(`api/apiToken/generateApiTokenForMe`, {
			Name: apiTokenName,
			ExpirationDays: 1,
		});
		return apiTokenResponse.ApiToken;
	}

	async _getApiTokenObjectId(apiTokenName) {
		return (
			await this.dataService.Fragments.getList('PLSTSApiTokenBase', {
				Columns: 'Name, Id',
				Where: `Name = '${apiTokenName}'`,
			})
		)[0]?.Id;
	}

	async _deleteApiToken(apiTokenName) {
		const tokenObjectId = await this._getApiTokenObjectId(apiTokenName);
		await this.dataService.Objects.delete('PLSTSApiTokenType', tokenObjectId);
	}
}
